import { withStyles } from '@material-ui/core/styles';
import PriceAdjustButton from './PriceAdjustButton';
import styles from './PriceAdjustButton.styles';

export default withStyles(styles)(PriceAdjustButton);
